import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormControl,
} from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
})
export class CheckboxComponent {
  @Input() checked: boolean;
  @Input() checkBoxColor: String = '#81B5B1';
  @Input() id: string;
  @Input() labelPosition: 'before' | 'after';
  @Input() disabled: boolean = false;
  @Input() name: string | null;
  @Input() value: string;
  @Output() checkedChange = new EventEmitter<boolean>();
  @Input() label: string;
  @Input() labelClassName: string;
  @Input() labelColor: string = '#042A32';
  @Input() labelFontSize: string = '14px';
  @Input() isOutlined: boolean = false;


  checkboxControl: FormControl;
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor() {
    this.checkboxControl = new FormControl(false);
  }

  ngOnInit() {
    this.checkboxControl.valueChanges.subscribe((value) => {
      this.onChange(value);
      this.onTouched();
    });
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.checkboxControl.setValue(value);
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    if (isDisabled) {
      this.checkboxControl.disable();
    } else {
      this.checkboxControl.enable();
    }
  }
}
